namespace HA.Core.Entity {
    export class HAApp extends App {

        /**
         * @returns {Map<any, any>}
         */
        public getQMenu() {

            if (this.has("qmenu")) {
                return super.getQMenu();
            }
            if (this.hasNavigation()) {
                return this.getNavigation().getQMenu();
            }
        }
        /**
         *
         * @returns {boolean}
         */
        public hasNavigation() {
            return this.has("navigation");
        }

        /**
         *
         * @returns {HANavigationApp}
         */
        public getNavigation() {
            return this.get("navigation");
        }
    }
}
